import React from 'react';
import './Sidebar.css';
import { t } from './i18n';

const ICONS = {
  map: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 20l-5.5 2 0-14 5.5-2 6 2 5.5-2 0 14-5.5 2-6-2z" />
      <path d="M9 6v14M15 4v14" />
    </svg>
  ),
  insights: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 3v18h18" />
      <path d="M7 14l3-4 3 3 4-6" />
    </svg>
  ),
  filters: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 5h16M7 12h10M10 19h4" />
    </svg>
  ),
  import: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3v12M8 11l4 4 4-4" />
      <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
    </svg>
  ),
};

const NAV_ITEMS = [
  { key: 'map', label: 'Mapa' },
  { key: 'insights', label: 'Insights' },
  { key: 'filters', label: 'Filtros' },
  { key: 'import', label: t('web.sidebar.importHealth') },
];

function Sidebar({ activeNav, onNavigate }) {
  return (
    <aside className="app-sidebar" aria-label={t('web.layout.nav.a11y')}>
      <div className="sidebar-brand">
        <span className="sidebar-brand-mark">
          <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 20l-5.5 2 0-14 5.5-2 6 2 5.5-2 0 14-5.5 2-6-2z" />
            <path d="M9 6v14M15 4v14" />
          </svg>
        </span>
        <span>
          <span className="sidebar-brand-name">Percurso</span>
          <span className="sidebar-brand-sub">seu mapa de vida</span>
        </span>
      </div>

      <nav className="sidebar-nav">
        {NAV_ITEMS.map((item) => (
          <button
            key={item.key}
            type="button"
            className={`sidebar-nav-item${activeNav === item.key ? ' active' : ''}`}
            onClick={() => onNavigate(item.key)}
            aria-current={activeNav === item.key ? 'page' : undefined}
          >
            {ICONS[item.key]}
            <span className="sidebar-nav-label">{item.label}</span>
          </button>
        ))}
      </nav>
    </aside>
  );
}

export default Sidebar;
